// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popup, List, Button } from 'semantic-ui-react';
// local
import { STATUS } from 'salvus-shared/consts/client';

class Clients extends Component {
    constructor(props) {
        super(props);
        this.state = { opened: false };
    }

    handleOpen = () => this.setState({ opened: true });

    handleClose = () => this.setState({ opened: false });

    handleClickTrigger = e => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ opened: true });
    };

    handleEdit = () => {
        this.handleClose();
        this.props.onClickEdit(this.props.client);
    };

    handleEnable = () => {
        this.handleClose();
        this.props.onClickEnable(this.props.client);
    };

    handleDisable = () => {
        this.handleClose();
        this.props.onClickDisable(this.props.client);
    };

    render() {
        const { client } = this.props;
        const { opened } = this.state;
        const trigger = <Button circular icon="ellipsis vertical" className="trigget-popup-patient" onClick={this.handleClickTrigger} />;
        const enabled = client.status === STATUS.ENABLED;
        const disabled = client.status === STATUS.DISABLED;
        const content = (
            <List className="patient-popup">
                <List.Item>
                    <Button className={!enabled ? '' : 'highlight'} onClick={this.handleEdit} content="Editar" />
                </List.Item>
                {!enabled && (
                    <List.Item>
                        <Button className="highlight" onClick={this.handleEnable} content={disabled ? 'Reativar' : 'Iniciar'} />
                    </List.Item>
                )}
                {enabled && (
                    <List.Item>
                        <Button onClick={this.handleDisable} content="Desativar" />
                    </List.Item>
                )}
            </List>
        );
        return (
            <Popup
                open={opened}
                onOpen={this.handleOpen}
                onClose={this.handleClose}
                trigger={trigger}
                content={content}
                position="bottom center"
                on="click"
                hideOnScroll
            />
        );
    }
}

Clients.propTypes = {
    client: PropTypes.object,
    onClickEdit: PropTypes.func,
    onClickEnable: PropTypes.func,
    onClickDisable: PropTypes.func,
};

export default Clients;
